import { NAME as APP_NAME } from '../constants';

export const NAME = `${APP_NAME}/SHEETS`;

export const REDUCER_NAME = 'sheets';

export const UPLOAD_URL = `${SHIPPING_EDGE}/api/shipments/uploadBatchShipmentsFile`;

export const ROUTES = {
  ROOT: '/sheets',
};

export const SHIPMENT_ADDRESS_STATUS = {
  CORRECT: 'CORRECT',
  MISSING: 'MISSING',
};

export const DATA_APPROVAL_STATUS = {
  INITIAL: 'INITIAL',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
};
export const CSV_HEADERS = {
  REF_ID: 'Reference Id',
  NAME: 'Customer Name',
  PHONE: 'Customer Phone',
  ADDRESS: 'Customer Address',
  EMAIL: 'Customer Email',
  CITY: 'Customer City',
  COUNTRY: 'Customer Country',
  WEIGHT: 'Item Weight (kg)',
  LENGTH: 'Item Length (cm)',
  WIDTH: 'Item Width (cm)',
  HEIGHT: 'Item Height (cm)',
  COD_AMOUNT: 'COD Amount',
  COD_CURRENCY: 'COD Currency',
  DESCRIPTION: 'Item Description',
  LATITUDE: 'Latitude',
  LONGITUDE: 'Longitude',
  BOXES: 'Boxes',
  SHIPMENT_VALUE: 'Shipment Value',
};

export const CSV_REQUIRED_HEADERS = [
  CSV_HEADERS.NAME,
  CSV_HEADERS.CITY,
  CSV_HEADERS.COUNTRY,
  CSV_HEADERS.PHONE,
  CSV_HEADERS.ADDRESS,
  CSV_HEADERS.DESCRIPTION,
  CSV_HEADERS.WEIGHT,
  CSV_HEADERS.LENGTH,
  CSV_HEADERS.WIDTH,
  CSV_HEADERS.HEIGHT,
  CSV_HEADERS.COD_AMOUNT,
  CSV_HEADERS.COD_CURRENCY,
  CSV_HEADERS.BOXES,
  CSV_HEADERS.SHIPMENT_VALUE,
];
